import CafePOSSystem from "./CafePOSSystem";

function App() {
  return <CafePOSSystem />;
}

export default App;
